wp.domReady( () => {

	/**
	 * Add custom styles to Button block
	 */
	wp.blocks.registerBlockStyle( 'yoast-seo/breadcrumbs', [
		{
			name: 'default',
			label: 'Default',
			isDefault: true,
		},
		{
			name: 'smoobu',
			label: 'Smoobu',
		}
	] );

} );
